import React from 'react'
import { ContactForm, Hero, Projects, Skills, TechStack } from '../../components'

import './home.css'

const Home = () => {

  return (
    <>
      <div className='main-content-wrapper'>
        <Hero />
        <Skills />
        <TechStack />
        <Projects />
        <ContactForm />
      </div>
    </>
  )
}

export default Home